import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { PostAskRequestEmail } from 'domain/usecases/ask-customer/post-create-ask-request-email';
import { RemotePostAskRequestEmail } from 'data/usecases/ask-customer/remote-post-create-ask-request-email';

export const makeRemotePostQueueRequestEmail = (): PostAskRequestEmail => {
  return new RemotePostAskRequestEmail(makeApiUrl('/queue/requests/email'), makeAuthorizeHttpClientDecorator());
};
